import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { CRYPTO, KOREA, US } from "utils/constant/ITME_INFO";
import { FIVEMIN_DELAY } from "utils/constant/STATUS";
import dateStatus from "utils/priceUpdateStatus";
import {
  AdjCloseChange,
  AdjCloseChangeAfterMaket,
  AdjCloseCHG,
  AdjCloseCHGAfterMaket,
} from "utils/detailAsset";
import { getCurrentKSTDate } from "utils/useFormattedDate";

function PriceStatus({
  detailData,
  toggleActive,
  isHoliday = false,
}: {
  detailData: any;
  toggleActive: boolean;
  isHoliday?: boolean;
}) {
  const router = useRouter();
  const { t } = useTranslation("detail");

  const now = getCurrentKSTDate();
  const hours = now.getHours();
  const minutes = now.getMinutes();

  const IS_US_TRADING_TIME = detailData?.IS_US_TRADING_TIME || false;
  const IS_US_PRE_MARKET_TIME = detailData?.IS_US_PRE_MARKET_TIME || false;
  const IS_US_STANDARD_ORDER_TIME =
    detailData?.IS_US_STANDARD_ORDER_TIME || false;
  const IS_US_AFTER_MARKET_TIME = detailData?.IS_US_AFTER_MARKET_TIME || false;
  const LOC = detailData?.LOC;

  //종가 날짜
  let closeDate = detailData && detailData.BASE_DT;
  if (detailData.ITEM_CD > 50000000 && detailData?.LOC === KOREA) {
    if (hours >= 9 && (hours < 16 || (hours === 16 && minutes <= 30))) {
      closeDate =
        detailData && detailData?.UDT_DT ? detailData?.UDT_DT : closeDate;
    } else if (detailData?.rnk !== 1) {
      detailData && detailData?.UDT_DT ? detailData?.UDT_DT : closeDate;
    }
  } else if (detailData?.CAT === "Index" && detailData?.LOC === KOREA) {
    // 한국 지수: 장중(당일 종가 적재 전)에는 최신 BASE_DT가 전일이므로,
    // 실시간(5분) 값이 있으면 당일 UDT_DT로 날짜 표시 (개별주와 동일)
    if (hours >= 9 && (hours < 16 || (hours === 16 && minutes <= 30))) {
      closeDate =
        detailData && detailData?.UDT_DT ? detailData?.UDT_DT : closeDate;
    }
  } else if (detailData.CAT === "Crypto") {
    closeDate = detailData && detailData?.UDT_DT;
  } else if (
    detailData.ITEM_CD > 20000000 &&
    detailData.ITEM_CD < 30000000 &&
    detailData?.LOC === US
  ) {
    if ((IS_US_STANDARD_ORDER_TIME || IS_US_AFTER_MARKET_TIME) && !isHoliday) {
      closeDate =
        detailData && detailData?.UDT_DT ? detailData?.UDT_DT : closeDate;
    }
  }

  const formatData = () => {
    if (!Date.parse(closeDate)) {
      console.error("Invalid date string:", closeDate);
      return "Invalid date";
    }

    const month = closeDate.split("T")[0].split("-")[1];
    const day = closeDate.split("T")[0].split("-")[2];

    return router.locale === "ko"
      ? `${Number(month)}월 ${Number(day)}일`
      : `
    ${Number(month)}.${Number(day)}
    `;
  };

  const cat =
    detailData?.LOC === KOREA && detailData.USE_YN_5MIN === 1
      ? KOREA
      : detailData?.LOC === US &&
        detailData.ITEM_CD < 30000000 &&
        detailData.ITEM_CD > 20000000
      ? US
      : detailData?.CAT === CRYPTO
      ? CRYPTO
      : "";

  const [currentStatus, setCurrentStatus] = useState("");
  useEffect(() => {
    if (!detailData) return;
    const saveData = async () => {
      const currentStatus = await dateStatus(
        router,
        cat,
        isHoliday,
        detailData
      );
      setCurrentStatus(currentStatus);
    };
    saveData();
  }, [isHoliday, cat]);

  const FiveMinDelay = () => {
    return (
      <div className="flex items-center ">
        <Icon />
        <span className={`${TYPO.TYPO7_1_RG} text-gray40`}>5분 지연</span>
      </div>
    );
  };

  if (detailData?.CAT === "Index" && detailData?.LOC === US) {
    return (
      <div className="flex flex-col py-1 justify-center">
        <div className="flex items-center gap-1 ">
          <span
            className={`${TYPO.TYPO7_RG} text-gray50 flex flex-col gap-1 items-center `}
          >
            {formatData()}
          </span>

          <div
            className={`${
              detailData?.ADJ_CLOSE_CHG.toFixed(1) == "0.0"
                ? "text-gray50"
                : detailData?.ADJ_CLOSE_CHG > 0
                ? "text-red40"
                : "text-blue40"
            }  flex item-center`}
          >
            <p className={` ${TYPO.TYPO7_RG}`}>
              {detailData?.ADJ_CLOSE_CHG.toFixed(1) == "0.0"
                ? ""
                : detailData?.ADJ_CLOSE_CHG > 0
                ? "+"
                : "-"}
              {detailData &&
                AdjCloseChange(detailData, router.locale, toggleActive)}
              {detailData && AdjCloseCHG(detailData)}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col py-1 justify-center">
      <div className="flex items-center gap-1 ">
        <span
          className={`${TYPO.TYPO7_RG} text-gray50 flex flex-col gap-1 items-center `}
        >
          {formatData()}
          {/* {LOC === US && IS_US_PRE_MARKET_TIME ? "프리마켓" : formatData()}{" "} */}
        </span>

        <div
          className={`${
            detailData?.ADJ_CLOSE_CHG.toFixed(1) == "0.0"
              ? "text-gray50"
              : detailData?.ADJ_CLOSE_CHG > 0
              ? "text-red40"
              : "text-blue40"
          }  flex item-center`}
        >
          <p className={` ${TYPO.TYPO7_RG}`}>
            {detailData?.ADJ_CLOSE_CHG.toFixed(1) == "0.0"
              ? ""
              : detailData?.ADJ_CLOSE_CHG > 0
              ? "+"
              : "-"}
            {detailData &&
              AdjCloseChange(detailData, router.locale, toggleActive)}
            {detailData && AdjCloseCHG(detailData)}
          </p>
        </div>
        <div>
          {(LOC === US && IS_US_STANDARD_ORDER_TIME) ||
          (LOC === KOREA && currentStatus === FIVEMIN_DELAY) ? (
            <FiveMinDelay />
          ) : null}
        </div>
      </div>
      {LOC === US &&
        (IS_US_AFTER_MARKET_TIME || isHoliday || !IS_US_TRADING_TIME) && (
          <div className="flex items-center gap-1 ">
            <div
              className={`${TYPO.TYPO7_RG} text-gray50 flex flex-col gap-1 `}
            >
              <span>{t("afterMarket")} </span>
            </div>
            <div
              className={`${
                detailData?.ADJ_CLOSE_CHG_AFTER?.toFixed(1) == "0.0"
                  ? "text-gray50"
                  : detailData?.ADJ_CLOSE_CHG_AFTER > 0
                  ? "text-red40"
                  : "text-blue40"
              }  flex item-center`}
            >
              <p className={` ${TYPO.TYPO7_RG}`}>
                {detailData?.ADJ_CLOSE_CHG_AFTER?.toFixed(1) == "0.0" &&
                detailData.ADJ_CLOSE_CHANGE_AFTER?.toFixed(2) === "0.00"
                  ? ""
                  : detailData?.ADJ_CLOSE_CHG_AFTER > 0
                  ? "+"
                  : "-"}
                {detailData &&
                  AdjCloseChangeAfterMaket(
                    detailData,
                    router.locale,
                    toggleActive
                  )}
                {detailData && AdjCloseCHGAfterMaket(detailData)}
              </p>
            </div>
            <div>{IS_US_AFTER_MARKET_TIME ? <FiveMinDelay /> : null}</div>
          </div>
        )}
    </div>
  );
}
const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_17622_4274"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17622_4274)">
        <path
          d="M10.1654 3.33489C9.93203 3.33489 9.73481 3.25433 9.5737 3.09322C9.41259 2.93211 9.33203 2.73489 9.33203 2.50155C9.33203 2.26822 9.41259 2.071 9.5737 1.90989C9.73481 1.74878 9.93203 1.66822 10.1654 1.66822C10.3987 1.66822 10.5959 1.74878 10.757 1.90989C10.9181 2.071 10.9987 2.26822 10.9987 2.50155C10.9987 2.73489 10.9181 2.93211 10.757 3.09322C10.5959 3.25433 10.3987 3.33489 10.1654 3.33489ZM10.1654 14.3349C9.93203 14.3349 9.73481 14.2543 9.5737 14.0932C9.41259 13.9321 9.33203 13.7349 9.33203 13.5016C9.33203 13.2682 9.41259 13.071 9.5737 12.9099C9.73481 12.7488 9.93203 12.6682 10.1654 12.6682C10.3987 12.6682 10.5959 12.7488 10.757 12.9099C10.9181 13.071 10.9987 13.2682 10.9987 13.5016C10.9987 13.7349 10.9181 13.9321 10.757 14.0932C10.5959 14.2543 10.3987 14.3349 10.1654 14.3349ZM12.832 5.66822C12.5987 5.66822 12.4015 5.58766 12.2404 5.42655C12.0793 5.26544 11.9987 5.06822 11.9987 4.83489C11.9987 4.60155 12.0793 4.40433 12.2404 4.24322C12.4015 4.08211 12.5987 4.00155 12.832 4.00155C13.0654 4.00155 13.2626 4.08211 13.4237 4.24322C13.5848 4.40433 13.6654 4.60155 13.6654 4.83489C13.6654 5.06822 13.5848 5.26544 13.4237 5.42655C13.2626 5.58766 13.0654 5.66822 12.832 5.66822ZM12.832 12.0016C12.5987 12.0016 12.4015 11.921 12.2404 11.7599C12.0793 11.5988 11.9987 11.4016 11.9987 11.1682C11.9987 10.9349 12.0793 10.7377 12.2404 10.5766C12.4015 10.4154 12.5987 10.3349 12.832 10.3349C13.0654 10.3349 13.2626 10.4154 13.4237 10.5766C13.5848 10.7377 13.6654 10.9349 13.6654 11.1682C13.6654 11.4016 13.5848 11.5988 13.4237 11.7599C13.2626 11.921 13.0654 12.0016 12.832 12.0016ZM13.832 8.83489C13.5987 8.83489 13.4015 8.75433 13.2404 8.59322C13.0793 8.43211 12.9987 8.23489 12.9987 8.00155C12.9987 7.76822 13.0793 7.571 13.2404 7.40989C13.4015 7.24878 13.5987 7.16822 13.832 7.16822C14.0654 7.16822 14.2626 7.24878 14.4237 7.40989C14.5848 7.571 14.6654 7.76822 14.6654 8.00155C14.6654 8.23489 14.5848 8.43211 14.4237 8.59322C14.2626 8.75433 14.0654 8.83489 13.832 8.83489ZM1.33203 8.00155C1.33203 6.25711 1.91259 4.75711 3.0737 3.50155C4.23481 2.246 5.65981 1.53489 7.3487 1.36822C7.52648 1.346 7.67925 1.39878 7.80703 1.52655C7.93481 1.65433 7.9987 1.81266 7.9987 2.00155C7.9987 2.17933 7.94036 2.33489 7.8237 2.46822C7.70703 2.60155 7.55981 2.67933 7.38203 2.70155C6.03759 2.85711 4.91536 3.43489 4.01536 4.43489C3.11536 5.43489 2.66536 6.62378 2.66536 8.00155C2.66536 9.39044 3.11536 10.5821 4.01536 11.5766C4.91536 12.571 6.03759 13.146 7.38203 13.3016C7.55981 13.3238 7.70703 13.4016 7.8237 13.5349C7.94036 13.6682 7.9987 13.8238 7.9987 14.0016C7.9987 14.1904 7.93481 14.3488 7.80703 14.4766C7.67925 14.6043 7.52648 14.6571 7.3487 14.6349C5.6487 14.4682 4.22092 13.7571 3.06536 12.5016C1.90981 11.246 1.33203 9.746 1.33203 8.00155ZM7.9987 9.33489C7.63203 9.33489 7.31814 9.20433 7.05703 8.94322C6.79592 8.68211 6.66536 8.36822 6.66536 8.00155C6.66536 7.946 6.66814 7.88766 6.6737 7.82655C6.67925 7.76544 6.69314 7.70711 6.71536 7.65155L5.7987 6.73489C5.67648 6.61266 5.61536 6.45711 5.61536 6.26822C5.61536 6.07933 5.67648 5.92378 5.7987 5.80155C5.92092 5.67933 6.07648 5.61822 6.26536 5.61822C6.45425 5.61822 6.60981 5.67933 6.73203 5.80155L7.6487 6.71822C7.69314 6.70711 7.80981 6.69044 7.9987 6.66822C8.36536 6.66822 8.67925 6.79878 8.94036 7.05989C9.20148 7.321 9.33203 7.63489 9.33203 8.00155C9.33203 8.36822 9.20148 8.68211 8.94036 8.94322C8.67925 9.20433 8.36536 9.33489 7.9987 9.33489Z"
          fill="var(--gray40)"
        />
      </g>
    </svg>
  );
};
export default PriceStatus;
